import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup'
import './styles.scss'

function Footer() {
  return (
    <footer className=''>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-md-6'>
            <h4 className='text-left'>Links de Interés</h4>
            <ListGroup variant='flush'>
              <ListGroup.Item
                action
                href='https://rancagua.digital/#/olvide-contrasena'
              >
                Recuperar Contraseña
              </ListGroup.Item>
              <ListGroup.Item action href='https://rancagua.digital/#/registro'>
                Crea tu cuenta
              </ListGroup.Item>
              <ListGroup.Item action href='mailto:soporte@innovarancagua.cl'>
                Contacto
              </ListGroup.Item>
              <ListGroup.Item action href='https://vecino.rancagua.digital/'>
                Tarjeta Vecino
              </ListGroup.Item>
              <ListGroup.Item action href='https://www.innovarancagua.cl/'>
                Corporación de Desarrollo & Innovación
              </ListGroup.Item>
            </ListGroup>
          </div>
          <div className='col-12 col-md-6 align-self-center '>
            <div className='innova'>
              <img
                className='img-fluid'
                alt='innovarancagua'
                src='/assets/innova.svg'
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
